"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRegistrationHistoryRoutes = void 0;
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const permissions_1 = require("@Const/permissions");
const navigation_1 = __importDefault(require("@App/navigation"));
const RightsholderRegistrationHistoryLayout_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationHistory/RightsholderRegistrationHistoryLayout"));
const route_1 = require("@App/navigation/route");
const RightsholderCatalogRegistrationHistory_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationHistory"));
const ViewWorkInternalScene_1 = __importDefault(require("@Scenes/WorkScenes/ViewWorkInternalScene"));
const fetch_type_enum_1 = require("@Components/WorkItemV2/fetch-type-enum");
const react_1 = __importDefault(require("react"));
const createRegistrationHistoryRoutes = () => ({
    path: '',
    element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_work_registration_status], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
        react_1.default.createElement(RightsholderRegistrationHistoryLayout_1.default, null))),
    children: [
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.registrationHistory.root,
            element: react_1.default.createElement(RightsholderCatalogRegistrationHistory_1.default, null),
        },
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.catalog.viewWork,
            element: react_1.default.createElement(ViewWorkInternalScene_1.default, { fetchType: fetch_type_enum_1.FetchType.HFA }),
        },
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.registrationHistory.submission,
            element: react_1.default.createElement(ViewWorkInternalScene_1.default, { fetchType: fetch_type_enum_1.FetchType.MLC }),
        },
        {
            path: route_1.RIGHTSHOLDER_SUB_ROUTES.registrationHistory.transaction,
            element: react_1.default.createElement(ViewWorkInternalScene_1.default, { fetchType: fetch_type_enum_1.FetchType.TRANSACTION }),
        },
    ],
});
exports.createRegistrationHistoryRoutes = createRegistrationHistoryRoutes;
